// extracted by mini-css-extract-plugin
module.exports = {"markdown":"ReadOnly_markdown__C7wRc"};